<template>
  <div class="temporary-sign">
    <!-- 创建二维码 -->
    <div class="temporary-sign-top">
      <div class="welcome">Hi，欢迎使用临时工打卡！</div>
      <div class="create-company">
        <div class="create-company-tips">
          <p class="title">快速创建打卡二维码</p>
          <p class="sub-title">从创建二维码开始，管理你的临时工出勤情况</p>
        </div>
        <el-button @click="openCreateQRCode(1)" class="btn-blue" icon="el-icon-plus">创建二维码</el-button>
      </div>
    </div>

    <!-- 二维码列表 -->
    <div class="temporary-sign-main">
      <div
        class="company-row"
        v-for="(item, index) in qrCodeList"
        :key="index"
      > 
        <div class="company-row-content" :class="{'is-active': !item.status}">
          <div class="titile-container">
            <div class="titile-container-left">
              <img v-if="item.status" src="../../../../assets/images/scanning-code.png" class="scanning-code">
              <img v-else src="../../../../assets/images/scanning-conde-grey.png" class="scanning-code">
              <p v-if="item.status" class="name" @click="downQrCode(item)">点击下载考勤码</p>
              <p v-else class="name no-download">点击下载考勤码</p>
            </div>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <span class="more"></span>
              </span>
              <el-dropdown-menu slot="dropdown" class="qrcode-human" :class="{'open-qrcode':!item.status}">
                <el-dropdown-item v-if="item.status" :command="beforeHandleCommand(item, 'close')">关闭此码</el-dropdown-item>
                <el-dropdown-item v-else :command="beforeHandleCommand(item, 'open')">开启此码</el-dropdown-item>
                <el-dropdown-item v-if="item.status" :command="beforeHandleCommand(item, 'mod')">编辑此码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div :id="`screenshot${item.id}`" class="screenshot-container">
            <div class="qrcode-container">
              <div class="qrcode-img">
                <div class="qrcode" :id="`temQrCode${item.id}`"></div>
                <div class="full animated fadeIn" v-if="item.status" @click="fullsreen(item)">
                  <img class="fullsreen" src="../../../../assets/images/fullsreen.png">
                  <span class="full-btn">点击放大</span>
                </div>
                <div class="invalid" v-if="!item.status">
                  <span>已失效</span>
                </div>
              </div>
            </div>
            <p class="warehouse-name">{{ item.warehouseName }}</p>
            <p class="company-name">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="look-img" v-if="lookImg" @click="closeLookImg">
      <img :src="url" @click.stop>
    </div>

    <!-- 新增二维码 -->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <el-form
        ref="qrcodeForm"
        :rules="qrcodeFormRules"
        :model="qrcodeForm"
      >
        <el-form-item prop="warehouseId" label="仓库名称">
          <el-select
            v-model="qrcodeForm.warehouseId"
            placeholder="请选择仓库"
            class="white"
            :disabled="drawerType == 2"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="产线名称">
          <el-input v-model="qrcodeForm.name" placeholder="请输入" :disabled="drawerType == 2"></el-input>
        </el-form-item>
        <el-form-item prop="account" label="WMS员工姓名">
          <el-input v-model="qrcodeForm.account" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submit('qrcodeForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import Team from "@/models/team.js";
import warehouseMixins from '@/common/mixins/warehouse.js'
import LaborServiceCompanyListMixins from '@/common/mixins/labor-service-company.js'
import { downLoadFile } from "common/js/util";
export default {
  mixins: [warehouseMixins, LaborServiceCompanyListMixins],

  data() {
    return {
      // 二维码列表
      qrCodeList: [],
      url: null,
      lookImg: false,
      
      drawer: false,
      drawerTitle: '创建',
      // 1是创建；2：是编辑
      drawerType: 1,
      qrcodeForm: {
        warehouseId: null,
        name: null,
        account: null,
        id: null
      },
      qrcodeFormRules: {
        warehouseId: [{ required: true, message: "请选择仓库", trigger: "change" }],
        name: [{ required: true, message: "请输入产线名称", trigger: "blur" }],
        account: [{ required: true, message: "请输入WMS验货员账号", trigger: "blur" }],
      },
      timerId: null,
    }
  },

  created() {
    this.initWarehouse()
    this.initLaborServiceCompanyList()
    this.initQrCodeList()
  },
  
  beforeDestroy() {
    clearTimeout(this.timerId)
  },

  methods: {
    /** 
     * @desc 获取二维码列表
    */
    initQrCodeList() {
      Team.getTeamQrCodeList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.warehouseId = i.warehouseId
            obj.name = i.name
            obj.wmsInspector = i.wmsInspector
            obj.warehouseName = i.warehouseName
            obj.url = `id=${i.id}`
            obj.status = i.status
            arr.push(obj)
          })
          this.qrCodeList = arr
          this.timerId = setTimeout(() => {
            this.qrCodeList.map(i => {
              this.creatQrCode(i.url, i.id)
            })
          }, 200)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 生产二维码
    */
    creatQrCode(url, id) {
      let temQrCodeId = `temQrCode${id}`
      document.getElementById(temQrCodeId).innerHTML = "";
      let qrcode = new QRCode(document.getElementById(temQrCodeId), {
        text: url, // 需要转换为二维码的内容
        width: 232,
        height: 232,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    },

    /** 
     * @desc 生产图片
    */
    createPicture(row, type) {
      let id = row.id
      let data = {
        useCORS: true,
        allowTaint: true,
        scrollY: 0,
        width: document.getElementById(`screenshot${id}`).scrollWidth,
        height: document.getElementById(`screenshot${id}`).scrollHeight
      }
      html2canvas(document.getElementById(`screenshot${id}`), data).then(canvas => {
        let imgUrl = canvas.toDataURL('image/png')
        if (type === 'look') {
          this.url = imgUrl
          this.lookImg = true
        } else {
          let name = `${row.name}二维码`
          downLoadFile(name, imgUrl)
        }
      })
    },

    /** 
     * @desc 开启二维码创建抽屉
     * @params type: 1是创建；2：是编辑
    */
    openCreateQRCode(type) {
      this.drawerTitle = type === 1?'创建':'编辑'
      this.drawerType = type
      this.drawer = true
    },
    
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value, command){
      return {
        'value': value,
        'command':command,
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "close":
          this.$confirm("关闭后，该考勤码将失效，请确认", "关闭", {
              confirmButtonText: "关闭",
              cancelButtonText: "取消",
              confirmButtonClass: 'btn-red',
              cancelButtonClass: 'btn-gray'
          }).then(() => {
            let data = {
              status: 0,
              id: command.value.id
            }
            Team.postUpdateTeamQrCodeStatus(data).then(res => {
              if (res.success) {
                this.initQrCodeList();
              } else {
                this.$message.error(res.message);
              }
            });
          });
        break;
        case "open":
          this.$confirm("开启后，该考勤码将生效，请确认", "开启", {
              confirmButtonText: "开启",
              cancelButtonText: "取消",
              confirmButtonClass: 'btn-blue',
              cancelButtonClass: 'btn-gray'
          }).then(() => {
            let data = {
              status: 1,
              id: command.value.id
            }
            Team.postUpdateTeamQrCodeStatus(data).then(res => {
              if (res.success) {
                this.initQrCodeList();
              } else {
                this.$message.error(res.message);
              }
            });
          });
        break;
        case "mod":
          this.qrcodeForm.warehouseId = command.value.warehouseId
          this.qrcodeForm.name = command.value.name
          this.qrcodeForm.account = command.value.wmsInspector
          this.qrcodeForm.id = command.value.id
          this.openCreateQRCode(2)
        break;
      }
    },
    
    handleCloseDrawer() {
      this.qrcodeForm.warehouseId = null
      this.qrcodeForm.name = null
      this.qrcodeForm.account = null
      this.qrcodeForm.id = null
      this.drawerTitle = '创建'
      this.drawerType = 1
      this.drawer = false;
    },

    /** 
     * @desc 保存二维码创建
    */
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.drawerType === 1) {
            let warehouseId = this.qrcodeForm.warehouseId;
            let name = this.qrcodeForm.name;
            let wmsInspector = this.qrcodeForm.account;
            let data = {
              warehouseId,
              name,
              wmsInspector,
            };
            Team.postAddTeamQrCode(data).then(res => {
              if (res.success) {
                this.handleCloseDrawer();
                this.initQrCodeList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            });
          } else {
            let id = this.qrcodeForm.id;
            let wmsInspector = this.qrcodeForm.account;
            let data = {
              id,
              wmsInspector,
            };
            Team.postModTeamQrCode(data).then(res => {
              if (res.success) {
                this.handleCloseDrawer();
                this.initQrCodeList();
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /** 
     * @desc 查看大图
    */
    fullsreen(row) {
      this.createPicture(row, 'look')
    },

    closeLookImg() {
      this.lookImg = false
      this.url = ''
    },
    
    /** 
     * @desc 下载二维码
    */
    downQrCode(row) {
      this.createPicture(row, 'down')
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/production/temporary-sign.scss';
</style>